/**
 * Created by tofael on 7/27/18.
 */

import React from 'react';
import {connect} from 'react-redux';

import moment from 'moment';
import StatsComponent from '../screens/stats/';
import api from '../utility/api';
import { asyncStart, asyncEnd, showFeedback } from '../actions/application';

moment.updateLocale('en', {
  week : {
    dow: 6
  }
});

const colors =  {
  'bad-call': '#000000',
  'emergency': '#D02504',
  'information': '#FF7E02',
  'mission-create': '#228B22',
  'no-response': '#EFB71E',
  'app': '#0486D0',
  'phone': '#228B22',
  'web': '#d0cd18'
};

function _formatStats(data, valueKey) {
  const formattedData = [];
  for (let key in data) {

    const [year, week] = key.split('-');
    const weekObject = moment(year).add(week, 'weeks');
    const firstDayOfWeek = weekObject.startOf('week').format('DD/MM');
    const lastDayOfWeek = weekObject.endOf('week').format('DD/MM');

    formattedData.push({name: `${firstDayOfWeek} - ${lastDayOfWeek}`, [valueKey]: data[key].length, year: parseInt(year, 10), week: parseInt(week, 10)});
  }

  formattedData.sort((a, b)=>{
    if (a.year < b.year) return -1;
    if (a.year > b.year) return 1;

    if (a.week < b.week) return -1;
    if (a.week > b.week) return 1;
    return 0;
  });

  return formattedData;
}

function _groupByWeek(data) {
  return data.reduce( function (acc, item) {
    const date = item.created_at;
    const yearWeek = moment(date).weekYear()+'-'+moment(date).week();
    if (typeof acc[yearWeek] === 'undefined') {
      acc[yearWeek] = [];
    }

    acc[yearWeek].push(date);

    return acc;

  }, {});

}

function _formatPieChartData(data) {
  let count = 0;
  let formattedData =  data.map(item=> {
    count+= item.reduction;
    return {name: item.group, value: item.reduction, color: colors[item.group]}
  });

  return {total:count, formattedData};
}
class Stats extends React.Component {

  constructor() {
    super(...arguments);
    this.state = {
      groupedMissions:[],
      groupedCalls: [],
      missionSources:[],
      callResults:[],
      totalMissions:0,
      totalCalls:0,
      callResultsTotal:0,
      missionSourcesTotal:0
    };
  };

  componentDidMount() {
    this.getStats();
  }

  getStats(fromDate, toDate){
    if(!toDate) {
        toDate = new Date().toISOString();
    }

    if(!fromDate) {
      fromDate = new Date();
      fromDate.setDate(fromDate.getDate() - 29);
    }

    this.props.dispatch(asyncStart());
    api.getStats(fromDate, toDate)
      .then((stats) => {
        this.props.dispatch(asyncEnd());

        const {mission, call, callResult, missionCallsSource} = stats;
        const missionGroup = _formatStats(_groupByWeek(mission), 'missions');
        const callsGroup = _formatStats(_groupByWeek(call), 'calls');
        const {total: callResultsTotal, formattedData:callResultPieChartData} = _formatPieChartData(callResult);
        const {total: missionSourcesTotal, formattedData:missionCallsSourcePieChartData} = _formatPieChartData(missionCallsSource);

        this.setState({
          groupedMissions:missionGroup,
          groupedCalls: callsGroup,
          missionSources: missionCallsSourcePieChartData,
          callResults: callResultPieChartData,
          totalMissions: mission.length,
          totalCalls: call.length,
          callResultsTotal,
          missionSourcesTotal
        });
      })
      .catch((e)=>{
        console.log(e);
        this.props.dispatch(asyncEnd());
        this.props.dispatch(showFeedback({message: 'Something went wrong.'}));
      })
  }

  render() {
    const {
      groupedMissions, groupedCalls, missionSources, callResults, totalMissions, totalCalls, missionSourcesTotal, callResultsTotal
    } = this.state;
    return (
      <StatsComponent
        calls={groupedCalls}
        missions={groupedMissions}
        missionSources={missionSources}
        callResults={callResults}
        totalMissions={totalMissions}
        totalCalls={totalCalls}
        missionSourcesTotal={missionSourcesTotal}
        callResultsTotal={callResultsTotal}
        onDateRangeChange={this.getStats.bind(this)}/>
    );
  }

};

function mapStateToProps(state) {
  return state.application;
}

export default connect(mapStateToProps, null)(Stats);



// WEBPACK FOOTER //
// ./src/containers/stats.js